import * as React from 'react'
import AppFeatureEditor from '../AppFeatureEditor'
import {Feature} from '../../../core/models'
import {GeometryType} from '../../../core/enums/GeometryType'
import OverlayLoader from '../../../core/components/Loading/OverlayLoading'
import GeometryEditor from '../../../core/components/FeatureViews/GeometryEditor'
import {CsSelector} from '../../../core/components/Controls/CsSelector'
import {AttachmentsViewer} from '../../../core/components/Controls/Attachments/AttachmentsViewer2'
import {AttachmentInfo, AttachmentInfos, IFeatureLayerInfo} from '../../../core/interfaces/models'
import {IFieldInfo} from '../../../core/interfaces/reducers'
class ArchAttachmentsViewer extends AttachmentsViewer {
  protected getAttachmentsList(stateAttachments: AttachmentInfos): JSX.Element {
    const attachments: Array<JSX.Element> = []
    for (const key in stateAttachments) {
      if (key.indexOf('__MAIN_PDF__') == -1) {
        attachments.push(
          <tr key={key}>
            <td>
              {stateAttachments[key].src ? (
                <a target="_blank" href={stateAttachments[key].src} rel="noreferrer">
                  {key}
                </a>
              ) : (
                <span>{key}</span>
              )}
            </td>
            <td>{this.getRemoveAttachmentButton(key)}</td>
          </tr>
        )
      }
    }
    if (attachments.length == 0) {
      return <div></div>
    }
    return (
      <div style={{width: '100%'}}>
        <b>Други файлове</b>
        <table className="table">
          <tbody>{attachments}</tbody>
        </table>
      </div>
    )
  }

  protected onAddAttachments(event: React.ChangeEvent<HTMLInputElement>): void {
    if (event.target.files && event.target.files.length > 0) {
      const newAttachmentInfos: AttachmentInfo[] = this.getNewAttachments(event.target.files)
      const promises: Promise<AttachmentInfo>[] = []
      if (this.props.previewIfPictures) {
        newAttachmentInfos.forEach(a => {
          promises.push(this.loadAttachment(a))
        })
        Promise.all(promises)
          .then(news => {
            this.applyNewAttachments(news)
          })
          .catch(e => {
            alert(e.message)
            console.error(e)
          })
      } else {
        this.applyNewAttachments(newAttachmentInfos)
      }

      this.fileInput.value = ''
    }
  }
  protected getAddAttachmentBtnText(): string {
    return 'Добави други файлове'
  }
  protected getAddAttachmentButton(stateAttachments: AttachmentInfos): JSX.Element {
    const title = this.getAddAttachmentBtnText()
    return (
      <div
        onClick={this.onAddAttachmentClick}
        style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}
        title={title}
      >
        <img src="resources/icons/add-file.svg" style={{width: '30px', height: '30px'}} alt="" />
        <div style={{width: '10px'}}></div>
        <div>{title}</div>
      </div>
    )
  }
  render() {
    return (
      <div className="arch-att-viewer">
        {this.getRealInput()}
        {this.getAttachmentsList(this.state.attachments)}
        {this.getAddAttachmentButton(this.state.attachments)}
      </div>
    )
  }
}

class ArchPdfAttachmentsViewer extends ArchAttachmentsViewer {
  protected getNewFileName(file: File): string {
    return `__MAIN_PDF__/${file.name}`
  }
  protected getAddAttachmentBtnText(): string {
    return 'Добави PDF на проекта'
  }
  protected getAddAttachmentButton(stateAttachments: AttachmentInfos): JSX.Element {
    const title = this.getAddAttachmentBtnText()
    let hasBtn = false
    for (const key in stateAttachments) {
      if (key.indexOf('__MAIN_PDF__') != -1) {
        hasBtn = true
      }
    }
    return hasBtn ? (
      <div></div>
    ) : (
      <div
        onClick={this.onAddAttachmentClick}
        style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}
        title={title}
      >
        <img src="resources/icons/add-file.svg" style={{width: '30px', height: '30px'}} alt="" />
        <div style={{width: '10px'}}></div>
        <div>{title}</div>
      </div>
    )
  }
  protected getAttachmentsList(stateAttachments: AttachmentInfos): JSX.Element {
    const attachments: Array<JSX.Element> = []
    for (const key in stateAttachments) {
      if (key.indexOf('__MAIN_PDF__') != -1) {
        attachments.push(
          <tr key={key}>
            <td>
              {stateAttachments[key].src ? (
                <a target="_blank" href={stateAttachments[key].src} rel="noreferrer">
                  {key}
                </a>
              ) : (
                <span>{key.replace('__MAIN_PDF__/', '')}</span>
              )}
            </td>
            <td>{this.getRemoveAttachmentButton(key)}</td>
          </tr>
        )
      }
    }
    if (attachments.length == 0) {
      return <div></div>
    }
    return (
      <div style={{width: '100%'}}>
        <b>PDF на проекта</b>
        <table className="table">
          <tbody>{attachments}</tbody>
        </table>
      </div>
    )
  }

  render() {
    return (
      <div className="arch-att-viewer">
        {this.getRealInput()}
        {this.getAttachmentsList(this.state.attachments)}
        {this.getAddAttachmentButton(this.state.attachments)}
      </div>
    )
  }
}
export class ArchGeometryEditor extends GeometryEditor {
  getProjectionSelector(): JSX.Element {
    return (
      <CsSelector
        className="form-control"
        selected={this.state.displayCS}
        onChange={s => {
          this.setState({...this.state, displayCS: s, loading: true})
          setTimeout(() => {
            this.geometryStringConverter
              .getGeometryAsStringAsync(
                (this.state && this.state.displayCS) || this.props.defaultDisplayCs,
                this.props.geometryType,
                this.props.feature.getGeometry()
              )
              .then(geometryString => {
                this.setState({...this.state, geometryString, loading: false})
              })
          }, 200)
        }}
      />
    )
  }
  getCoordinatesMessage(): JSX.Element {
    if (this.props.hideMessages) return <div></div>
    return (
      <React.Fragment>
        <br />
        <br />
        <div style={{textAlign: 'center', margin: '5px'}}>
          <div>Изчертайте или напишете координатите на полигона за обхват на проекта</div>
          <span>Координати:</span>
          <span>
            {this.props.showTransformSelector ? this.getProjectionSelector() : this.getCsLabel(this.state.displayCS)}
          </span>
        </div>
      </React.Fragment>
    )
  }
  protected getGeometryEditingTools(feature: Feature): JSX.Element {
    let content = <div></div>
    if (!this.props.geometryType) {
      return content
    }
    if (this.props.geometryType == GeometryType.Point) {
      content = this.getPointGeometryEditingTools(feature)
    } else if (
      this.props.geometryType == GeometryType.Polygon ||
      this.props.geometryType == GeometryType.LineString ||
      this.props.geometryType == GeometryType.MultiPolygon ||
      this.props.geometryType == GeometryType.MultiLineString
    ) {
      content = this.getShapeEditingTools()
    } else {
      throw new Error(`Editing "${this.props.geometryType}" not implemented yet`)
    }
    return (
      <div style={{position: 'relative', margin: '10px', minWidth: '300px', flex: 1}}>
        <OverlayLoader show={this.state.loading}></OverlayLoader>
        {this.getCoordinatesMessage()}
        {content}
        {this.props.geometryType == GeometryType.Point ? this.getGeometrySettingControl() : null}
        {this.state.errors
          ? this.state.errors.map((c, i) => (
              <div className="error-div" key={i}>
                {c}
              </div>
            ))
          : null}
      </div>
    )
  }
}
export class ArchPlanHistoryEditor extends AppFeatureEditor {
  protected isArchImportUser(): boolean {
    return !!this.props.user && !!this.props.user.isArchImportUser
  }

  protected processField(fieldInfo: IFieldInfo, layerInfo: IFeatureLayerInfo, feature: Feature): boolean {
    //if the user is control
    if (
      ['ArchPlanTypeId', 'Name', 'PlanCreatedDate'].indexOf(fieldInfo.fieldName) != -1 &&
      this.props.user &&
      this.props.user.isArchControl
    ) {
      return false
    }
    //if the plan is not new and the user is architect that can import
    else if (
      ['ArchPlanTypeId', 'Name'].indexOf(fieldInfo.fieldName) != -1 &&
      this.isArchImportUser() &&
      feature.get('ArchPlanHistoryStatusId') != 1
    ) {
      return false
    }
    return !!fieldInfo.editable
  }
  protected getAttachmentsViewer(feature: Feature): JSX.Element {
    return (
      <ArchAttachmentsViewer
        readonly={this.props.layerInfo.sourceDescription.attachmentsReadOnly}
        adds={feature.attachmentChanges.adds}
        updates={feature.attachmentChanges.updates}
        deletes={feature.attachmentChanges.deletes}
        multiple={true}
        attachments={feature.attachments}
        onAttachmentsChange={changes => {
          feature.attachmentChanges = changes
          this.applyChanges(feature)
        }}
        feature={feature}
        uploadToArchive={true}
      />
    )
  }

  protected getAttachmentsPDFViewer(feature: Feature): JSX.Element {
    return (
      <ArchPdfAttachmentsViewer
        readonly={this.props.layerInfo.sourceDescription.attachmentsReadOnly}
        adds={feature.attachmentChanges.adds}
        updates={feature.attachmentChanges.updates}
        deletes={feature.attachmentChanges.deletes}
        maxNumber={1}
        multiple={false}
        acceptTypes=".pdf"
        attachments={feature.attachments}
        onAttachmentsChange={changes => {
          feature.attachmentChanges = changes
          this.applyChanges(feature)
        }}
        feature={feature}
        uploadToArchive={true}
      />
    )
  }

  render() {
    const feature = this.props.editsDispatcher ? this.props.feature : this.state.feature
    if (this.state.success) {
      return (
        <div style={{padding: '10px', boxSizing: 'border-box'}}>
          <div className="success-div">Записът беше успешен</div>
          <button
            type="button"
            className={this.props.buttonsClassname || 'button width'}
            onClick={() => {
              this.props.editAgain(feature)
            }}
          >
            {'УСПЕШЕН ЗАПИС'}
          </button>
        </div>
      )
    }
    return (
      <div style={{...this.props.style, position: 'relative', height: '100%', overflow: 'auto'}}>
        <div style={{margin: '10px'}}>
          <OverlayLoader size="60px" show={this.state.loading} />
          {this.renderEditingBody(feature, this.props.layerInfo)}

          {this.isArchImportUser() ? this.getAttachmentsPDFViewer(feature) : null}
          {this.getAttachmentsViewer(feature)}

          {this.state.showGuiltyFields && this.controlsHaveErrors(feature) ? (
            <div className="error-div">Моля, оправете грешките</div>
          ) : null}
          {this.state.errorMessage ? <div className="error-div">{this.state.errorMessage}</div> : null}
          {this.getSaveControls(feature)}
          <br></br>
        </div>
      </div>
    )
  }
}
